
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/competitions/[competitionName]/leaderboard",
      function () {
        return require("private-next-pages/competitions/[competitionName]/leaderboard.tsx");
      }
    ]);
  